<div class="card flex justify-center" >
    <mat-stepper [linear]="true" #stepper *ngIf="labels"
    [disableRipple]="true"
         [selectedIndex]="this.step">
        @if ( this.step ) {
            <mat-step  *ngFor="let item of labels, let ix=index" 
                [label]="item"
                [editable]="this.isEditable"
                [completed]="this.step ? ix <= this.step : false">
            </mat-step>
        } @else {
            <mat-step  *ngFor="let item of labels, let ix=index" 
                [label]="item"
                [editable]="this.isEditable">
            </mat-step>
        }
    </mat-stepper>
</div>